import React from 'react';
import TenantMaintenanceContainer from '../../components/landlord-dashboard/maintenance/TenantMaintenanceContainer';
import { useAuth } from '../../auth/firebaseAuth';
import { Navigate } from 'react-router-dom';

const TenantMaintenancePage: React.FC = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Maintenance Requests</h1>
      <TenantMaintenanceContainer />
    </div>
  );
};

export default TenantMaintenancePage;
